import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';

const COLORS = [
  '#054287',
  '#0e5db9',
  '#1b76e0',
  '#1b76e0',
  '#2faae7',
  '#2faae7',
];

function QuickStats(props) {
  return (
    <div className="quick-stat-list">
      {props.stats.map((stat, i) => (
        <div key={stat.label} className="quick-stat-container">
          <div
            className="quick-stat"
            style={{ background: COLORS[i % COLORS.length] }}
          >
            {stat.tooltip && (
              <div className="tooltip-container">
                <Tooltip width={300} text={stat.tooltip}>
                  <div className="info-icon">i</div>
                </Tooltip>
              </div>
            )}
            <div className="quick-stat-label">{stat.label}</div>
            <div className="quick-stat-value">{stat.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
}

QuickStats.propTypes = {
  stats: PropTypes.array.isRequired,
};

export default QuickStats;
